<template>
  <div class="container">
    <Navbar />
    <div class="container">
      <div class="row justify-content-center mt-5">
        <div class="col text-center">
          <img src="../assets/images/waiting.svg" alt="" width="300" />
          <h2 class="mt-5 text-success"><strong>Pesanan Sukses</strong></h2>
          <h4>
            Pesanan anda segera diproses <br />
            Mohon Tunggu Beberapa saat 😊
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
export default {
  name: "PesananSukses",
  components: {
    Navbar,
  },
};
</script>

<style>
</style>